import "../styles/index.scss";
import "../trust/src/styles/index.scss";

import { ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import viVN from "antd/locale/vi_VN";
import { appWithTranslation } from "next-i18next";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import TagManager from "react-gtm-module";

import CareersNavbar from "@/components/careers/Navbar";
import CustomerNavbar from "@/components/customers/Navbar";
import LearnNavbar from "@/components/learn/Navbar";
import CyStackNghiDinh13 from "src/components/CyStackNghiDinh13";
import ModalJoinCyStackCommunity from "../components/CystackCommunity";
import CystackFooter from "../components/layout/Footer";
import CystackHeader from "../components/layout/Header";
import CystackSmeHeader from "../components/layout/SmeHeader";
import userServices from '@/services/user'
import {
  getCookie,
  setCookie,
} from 'cookies-next';
import { Provider } from 'react-redux';
import { setUserInfo } from '@/store/slices/resourceSlice';
import { wrapper } from '@/store/store';
import "highlight.js/styles/atom-one-dark.css";

const PhoneCall = () => (
  <a href="tel:+842471099656" className="fixed z-20 wrapper bottom-24 right-1">
    <div className="shadow-none">
      <div className="coccoc-alo-phone coccoc-alo-green coccoc-alo-show">
        <div className="coccoc-alo-ph-circle"></div>
        <div className="coccoc-alo-ph-circle-fill"></div>
        <div className="coccoc-alo-ph-img-circle"></div>
      </div>
    </div>
  </a>
);

function CyStack({ Component, pageProps, ...rest  }) {
  const { store } = wrapper.useWrappedStore(rest);
  const router = useRouter();
  const { locale } = router;

  const [isOpenCommunity, setIsOpenCommunity] = useState(false);
  const [subdomain, setSubdomain] = useState(null);

  const fetchUserInfo = async () => {
    try {
      const response = await userServices.getUserInfo();
      store.dispatch(setUserInfo(response));
    } catch (error) {
      store.dispatch(setUserInfo(null));
    }
  }

  useEffect(() => {
    TagManager.initialize({ gtmId: "GTM-T2W558J" });
    const firstLink = sessionStorage.getItem("first_link");
    if (!firstLink) {
      sessionStorage.setItem("first_link", window.location.href);
    }
    const accessToken = getCookie('access_token')
    if (accessToken) {
      fetchUserInfo()
    } else {
      if (router.query.token) {
        const accessToken = setCookie('access_token', JSON.stringify(accessToken))
        fetchUserInfo()
      }
    }
  }, []);

  useEffect(() => {
    setIsOpenCommunity(false);
  }, [router]);

  useEffect(() => {
    const isOpenedModalCommunity = sessionStorage.getItem(
      "is-opened-modal-community"
    );
    const includeRoute =
      router.asPath.includes("huong-dan-tuan-thu-nd13-phap-ly") ||
      router.asPath.includes("/pentest") ||
      router.asPath.includes("/data-protection") ||
      router.asPath.includes("/security-audit") ||
      router.asPath.includes("/blockchain-security") ||
      router.asPath.includes("/smart-contract-audit") ||
      router.asPath.includes("/penetration-testing");

    const webIncludeRoute = 
      router.pathname.includes('/services/penetration-testing') ||
      router.pathname.includes('/services/smart-contract-audit') ||
      router.pathname.includes('/solutions/blockchain-security') || 
      router.pathname.includes('/solutions/security-audit')

    if (!isOpenedModalCommunity && locale !== "en" && (!includeRoute || webIncludeRoute)) {
      const timeout = setTimeout(() => {
        setIsOpenCommunity(true);
        document.body.style.overflow = "hidden";
        sessionStorage.setItem("is-opened-modal-community", "true");
      }, 5000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [locale]);

  const handleCloseModal = () => {
    setIsOpenCommunity(false);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    if (window.$chatwoot) {
      window.$chatwoot.setLocale(locale);
    } else {
      window.chatwootSettings = window.chatwootSettings || {
        baseDomain: ".cystack.net",
      };
      window.chatwootSettings.locale = locale;
    }
  }, [locale]);

  useEffect(() => {
    const hostname = window.location.hostname;
    const parts = hostname.split(".");
    if (parts.length >= 2 && parts[0] === "sme") {
      setSubdomain(parts[0]);
    } else {
      setSubdomain(null);
    }
  }, []);

  useEffect(() => {
    const hiddenRoutes = ['/endpoint', '/admin']

    if (hiddenRoutes.some((route) => router.pathname.includes(route))) {
      return
    }

    // Đã có sẵn Chatwoot?
    if (document.getElementById('chatwoot-script')) return

    const script = document.createElement('script')
    var BASE_URL="https://chat.cystack.org";
    script.id = 'chatwoot-script'
    script.src = `${BASE_URL}/packs/js/sdk.js`
    script.defer = true
    script.async = true
    script.onload = () => {
      window.chatwootSDK.run({
        websiteToken: '3F7TNtvcJS6EQnFG9Jej4Cgc',
        baseUrl: BASE_URL,
      })
    }

    document.body.appendChild(script)
  }, [router.pathname])

  const getLayout =
    Component.getLayout ||
    ((page) => (
      <Provider store={store}>
        <ConfigProvider
          locale={locale === "vi" ? viVN : enUS}
          theme={{
            hashed: false,
            token: { colorPrimary: "#2222FF", fontFamily: "Inter" },
            controlHeight: router.pathname?.includes("/trust/[alias]")
              ? 44
              : null,
            borderRadius: router.pathname?.includes("/trust/[alias]")
              ? 6
              : null,
          }}
        >
          <PhoneCall />
          {subdomain && subdomain === "sme" ? (
            <CystackSmeHeader />
          ) : !router.pathname.includes("/trust") ||
            router.pathname.startsWith("/trust-center") ? (
            <CystackHeader />
          ) : null}
          {router.pathname.includes("/learn") && <LearnNavbar />}
          {(router.pathname.includes("/project") ||
            router.pathname.includes("/customer")) && <CustomerNavbar />}
          {router.pathname.includes("/careers") && <CareersNavbar />}
          <Head>
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=5, viewport-fit=cover"
            />
          </Head>
          <CyStackNghiDinh13
            isOpen={isOpenCommunity}
            closeModal={handleCloseModal}
          />
          {/* <ModalJoinCyStackCommunity
            isOpen={isOpenCommunity}
            closeModal={handleCloseModal}
          /> */}
          {page}
          {!router.pathname.includes("/trust") ||
            router.pathname.startsWith("/trust-center") ? (
            <CystackFooter subdomain={subdomain} />
          ) : null}
        </ConfigProvider>
      </Provider>
    ));

  return getLayout(<Component {...pageProps} />);
}

export default appWithTranslation(CyStack);
